const autosize = require('autosize')

$(() => {
  if (!$('.js-chat-gpt-search').length) {
    return
  }

  $(document).on('click', '.js-chat-gpt-search', function (e) {
    e.preventDefault();

    const $btn = $(this);
    const targetSelector = $btn.data('target');
    const siteId = $btn.data('site-id');
    const purpose = $btn.data('purpose');
    const format = $btn.data('format');

    // 元のボタンテキストを保存
    const originalText = $btn.text();
    $btn.text('生成中...').prop('disabled', true);

    $.ajax({
      url: '/admin/chat_gpts',
      method: 'GET',
      data: {
        site_id: siteId,
        purpose: purpose,
        format: format
      },
      success: function (response) {
        // レスポンスを指定のtextareaにセット
        try {
          const formatted = JSON.stringify(response, null, 2);
          const $textarea = $(targetSelector);

          $textarea.val(formatted);
          autosize.update($textarea[0]);
        } catch (e) {
          console.log(e)
          alert("レスポンスが不正です:\n" + response)
        }
      },
      error: function (xhr) {
        alert('GPTの生成に失敗しました');
        console.error(xhr);
      },
      complete: function () {
        // ボタンを元に戻す
        $btn.text(originalText).prop('disabled', false);
      }
    });
  });

})